import styled from '@emotion/styled';
import { InputHTMLAttributes } from 'react';

import { customPalette } from '../../../../styles/theme';

interface TextFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
  fullWidth?: boolean;
}

export const DialogWrapper = styled.div<{ open: boolean }>`
  display: ${({ open }) => (open ? 'flex' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;

  .modal-content {
    display: flex;
    flex-direction: column;
    background-color: ${customPalette.accent.white};
    border-radius: 20px;
    max-width: 500px;
    width: 100%;
    padding: 32px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    position: relative;

    .modal-close-button {
      position: absolute;
      top: -30px;
      right: -20px;
      padding: 5px;
      margin: 20px;
    }
  }
`;

export const CloseButtonWrapper = styled.div`
  position: absolute;
  top: 32px;
  right: 24px;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
`;

export const StyledDialogTitle = styled.h2`
  font-weight: bold;
  font-size: 28px;
  color: ${customPalette.grey.main};
  text-align: left;
  width: 100%;
`;

export const StyledDialogContent = styled.div`
  color: ${customPalette.grey.main};
  font-size: 14px;
  text-align: left;
  line-height: 1.4;
  width: 100%;
  padding-bottom: 24px;

  .paragraph-large {
    font-size: 18px;
    margin-bottom: 24px;
  }

  .paragraph-small {
    font-size: 14px;
    margin-bottom: 24px;
  }

  .input-label {
    font-size: 12px;
    color: ${customPalette.accent.main};
    margin-bottom: 8px;
  }
`;

export const NavigationButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 24px;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`;

export const StyledTextField = styled.input<TextFieldProps>`
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
  padding: 12px;
  font-size: 14px;
  color: ${({ error }) =>
    error ? customPalette.negative[600] : customPalette.accent.main};
  border: 1px solid
    ${({ error }) =>
      error ? customPalette.negative[600] : customPalette.grey[200]};
  border-radius: 8px;
  margin-bottom: 24px;
  box-sizing: border-box;
  height: ${({ style }) => style?.height || 'auto'};

  &::placeholder {
    color: grey;
  }

  &:focus {
    border-color: ${({ error }) =>
      error ? customPalette.negative[600] : customPalette.accent.main};
    outline: none;
  }
`;
